// normalizeAmtStr
// Params: num or string with no commas
// Returns: string with commas added
export const normalizeAmtStr = (amt, isDollarAmt) => {
  if (!isDollarAmt) return amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  else if (amt.toString().indexOf(".") >= 0)
    return `$${amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  else return `$${amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.00`;
};
